class CosProductRecommendations extends HTMLElement {
  connectedCallback() {
    const observer = new IntersectionObserver(this.handleIntersection, {
      rootMargin: '100% 0px',
      threshold: 0
    });
    observer.observe(this);
  }

  async initSlider() {
    const slider = this.querySelector('.products-slider:not(.keen-loaded)');
    if (!slider) return;

    try {
      const { default: KeenSlider, sliderArrows } = await import(window.modules['keen-slider']);  
      const settings = JSON.parse(
        slider.getAttribute('data-slider-settings')
      ) || {};
      settings.detailsChanged = (slider) => {
        if (!slider.options) return;
        if (slider.options.disabled) {
          slider.container.classList.remove('keen-loaded');
        } else {
          slider.container.classList.add('keen-loaded');
        }
      };
      settings.destroyed = (slider) => {
        slider.container.classList.remove('keen-loaded');
      };
  
      KeenSlider(slider, settings, [sliderArrows]);
    } catch (e) {
      if (typeof Bugsnag !== 'undefined') Bugsnag.notify(e);
      console.warn(e);
    }
  }

  handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(this);

    const url = this.dataset.url;
    
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cos-product-recommendations');
        
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          
          this.initSlider();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };
}
customElements.define('cos-product-recommendations', CosProductRecommendations);